import React from "react";
import { ArrowUpRight } from "lucide-react";

const PropertyCard = ({ item }) => {
  return (
    <a href={item.link || undefined} target={item.link ? "_blank" : undefined} rel="noopener noreferrer" className="group cursor-pointer block" data-testid={`listing-card-${item.id}`}>
      <div className="relative overflow-hidden bg-neutral-200">
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={item.image}
            alt={item.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
        </div>
        {item.tag && (
          <span className="absolute top-4 left-4 bg-[#0d0d0d]/85 text-white text-[10px] tracking-luxe px-3 py-1.5 uppercase">
            {item.tag}
          </span>
        )}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors duration-500 flex items-center justify-center">
          <span className="opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500 text-white text-[11px] tracking-luxe border border-white/70 px-6 py-3 flex items-center gap-2">
            VIEW PROPERTY <ArrowUpRight size={14} />
          </span>
        </div>
      </div>
      <div className="pt-5">
        <h3 className="font-serif-display text-2xl text-[#1a1a1a] mb-1">{item.name}</h3>
        <p className="text-[11px] tracking-luxe-sm text-neutral-500 uppercase mb-3">{item.address}</p>
        <div className="flex items-center gap-3 text-[12px] text-neutral-600 mb-3">
          {item.beds && <span>{item.beds} BD</span>}
          {item.beds && item.baths && <span className="text-neutral-300">|</span>}
          {item.baths && <span>{item.baths} BA</span>}
          {item.baths && item.sqft && <span className="text-neutral-300">|</span>}
          {item.sqft && <span>{item.sqft} {item.sqft !== "Studio" ? "Sq.Ft." : ""}</span>}
        </div>
        {item.price && (
          <p className="font-serif-display text-xl text-[#1a1a1a]">{item.price}</p>
        )}
      </div>
    </a>
  );
};

export default PropertyCard;
